<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
            <h3 class="primary--text formName">Upload a new image</h3>
          </v-card-title>
      <v-card-text>
        <div class="text-center">
          <label for="briefUp" class=" briefUploader"  v-if="!uploadProceed">
            <input type="file" name="briefUp" id="briefUp" @change="select" accept="image/*"/>
            Click to select your image
          </label>
          <div class="row" v-if="uploadProceed">
            <div class="col-12 text-center uploadProcess">
              <!-- <div class="progress">
                <span class="progressText">   Upload in progess. Please wait an instant ...</span>

              </div> -->
                <span class="progressText">Upload in progress. Please wait a moment.</span>
              <v-progress-linear
                v-model="progress"
                color="blue-grey"
                height="25"
              >
            </v-progress-linear>

            </div>

          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/tools/api';
import { toast } from 'vue-sonner'
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
  },

  data () {
    return{
      apiUrl: process.env.VUE_APP_API_URL,
      customerValue:'',
      returnedCustomerValue:'',
      file: null,
      chunks: [],
      uploaded: 0,
      uploadProceed: false,
      addedFile: null
    }
  },
  methods:{
    submit(){
      this.returnedCustomerValue = this.customerValue;
      this.customerValue = "";
       this.$emit('newValueIsProposed',this.returnedCustomerValue)
    },
    close(){
        this.$emit('close',false)
    },
    select(event) {
      this.uploaded = 0;
        this.file = event.target.files.item(0);
        this.createChunks();
        this.uploadProceed = true;
        // console.log(this.chunks);
        // this.upload();
    },
    upload() {
        api(this.config).then((r) => {
          console.log(r);
          this.chunks.shift();
          if(r.data)if(r.data)this.addedFile = r.data;
        }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
    },
    createChunks() {
        let size = 8192, chunks = Math.ceil(this.file.size / size);

        for (let i = 0; i < chunks; i++) {
            this.chunks.push(this.file.slice(
                i * size, Math.min(i * size + size, this.file.size), this.file.type
            ));
        }
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    },
    progress() {
      if(this.file){
          return Math.floor((this.uploaded * 100) / this.file.size);
      }
      else{return 0;}

    },
    formData() {
        let formData = new FormData;

        formData.set('is_last', this.chunks.length === 1);
        formData.set('file', this.chunks[0], `${this.file.name}.part`);
        formData.set('file_extension_original', this.file.name.split('.').pop());
        formData.set('fileType', this.fileType);
        return formData;
    },
    config() {
        return {
            method: 'POST',
            data: this.formData,
            url: this.apiUrl+'/restrict/just_upload_image',
          //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

            headers: {
                'Content-Type': 'application/octet-stream'
            },
            onUploadProgress: event => {
                this.uploaded += event.loaded;
            }
        };
    }
  },
  watch: {
    dialogVisible: function(){
      this.customerValue = "";
    },
    chunks: {
      handler(val) {
        if (val.length > 0) {
               this.upload();
        }
        else{
          this.uploadProceed = false;
          this.$emit("newValueIsProposed", this.addedFile);
        }
      },
      deep: true
    },
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }

  .prev_step_btn{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#3783C5;
      margin:5px;
  }
  .prev_step_btn img{
    margin-right:10px;
  }

  .briefUploader{
    cursor:pointer;
    border-bottom:2px solid #B38D2F;
    padding-bottom: 5px;
  }
  .briefUploader input[type="file"]{
    display:none;
  }



  .progressText{
    width:100%;
    display:block;
    margin-top:10px;
    margin-bottom:10px;
    text-align: center;
  }

.uploadProcess{

  padding:20px;
  border: 1px solid #DEDEDE;
}

</style>
